import React from "react";
import PropTypes from "prop-types";
import FilterEarner from "./desktop/FilterEarner";
import FilterPrime from "./desktop/FilterPrime";
import FilterCharacter from "./desktop/FilterCharacter";

function Filter(props) {
  const {
    type,
    setFilterData,
    filterData,
    showing,
    breedOptions,
    rankOptions,
    categoryOptions,
  } = props;

  const handleChangeFilter = (val) => {
    setFilterData(val);
  };

  return (
    <>
      {type == "dogmall" && (
        <FilterEarner
          filterData={filterData}
          showing={showing}
          breedOptions={breedOptions}
          rankOptions={rankOptions}
          setFilterData={(val) => handleChangeFilter(val)}
        />
      )}
      {type == "character" && (
        <FilterCharacter
          filterData={filterData}
          showing={showing}
          categoryOptions={categoryOptions}
          setFilterData={(val) => handleChangeFilter(val)}
        />
      )}
      {type == "nft_prime" && (
        <FilterPrime
          filterData={filterData}
          showing={showing}
          breedOptions={breedOptions}
          setFilterData={(val) => handleChangeFilter(val)}
        />
      )}
    </>
  );
}

Filter.propTypes = {
  type: PropTypes.string,
  setFilterData: PropTypes.func,
  filterData: PropTypes.object,
  showing: PropTypes.number,
};

export default Filter;
